import {
    ECOMMERCE_RULE_KEY,
    ECOMMERCE_RULE_TYPE,
} from "../EcommerceRule"
import {
    ECOMMERCE_RULE_FEATURE,
} from "../EcommerceRuleFeatures"
import { defineMessages } from "react-intl"

export const RULE_KEY_SELECT_MESSAGES = defineMessages({
    "select": {
        id: "ecommerce.rules_engine.rule_key.select",
        defaultMessage: "Select an attribute",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_TAGS]: {
        id: "ecommerce.rules_engine.rule_key.product_tags",
        defaultMessage: "Product tags",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_TYPES]: {
        id: "ecommerce.rules_engine.rule_key.product_types",
        defaultMessage: "Product types",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_IDS]: {
        id: "ecommerce.rules_engine.rule_key.product_ids",
        defaultMessage: "Product ids",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_NAMES]: {
        id: "ecommerce.rules_engine.rule_key.product_names",
        defaultMessage: "Product names",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_SKUS]: {
        id: "ecommerce.rules_engine.rule_key.product_skus",
        defaultMessage: "Product skus",
    },
    [ECOMMERCE_RULE_KEY.PRODUCT_AVAILABILITY]: {
        id: "ecommerce.rules_engine.rule_key.product_availability",
        defaultMessage: "Product availability",
    },
})

export const RULE_TYPE_SELECT_MESSAGES = defineMessages({
    "select": {
        id: "ecommerce.rules_engine.rule_type.select",
        defaultMessage: "Select the type of rule",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_INCLUDES_ONE_OF]: {
        id: "ecommerce.rules_engine.rule_type.includes_one_of",
        defaultMessage: "Must match at least one of the accepted values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_INCLUDES_ALL]: {
        id: "ecommerce.rules_engine.rule_type.includes_all",
        defaultMessage: "Must match all required values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_EXCLUDES_ALL]: {
        id: "ecommerce.rules_engine.rule_type.excludes_all",
        defaultMessage: "Must not be any of the excluded values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_CONTAINS_ONE_OF]: {
        id: "ecommerce.rules_engine.rule_type.contains_one_of",
        defaultMessage: "Must contain (partial match) at least one of the accepted values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_CONTAINS_ALL]: {
        id: "ecommerce.rules_engine.rule_type.contains_all",
        defaultMessage: "Must contain (partial match) all the required values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_CONTAINS_ALL]: {
        id: "ecommerce.rules_engine.rule_type.not_contains_all",
        defaultMessage: "Must not contain any of the excluded values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_IS_TRUE_OR_FALSE]: {
        id: "ecommerce.rules_engine.rule_type.is_true_or_false",
        defaultMessage: "Is",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_START_WITH_ONE_OF]: {
        id: "ecommerce.rules_engine.rule_type.start_with_one_of",
        defaultMessage: "Must start with at least one of the accepted values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_START_WITH_ALL]: {
        id: "ecommerce.rules_engine.rule_type.not_start_with_all",
        defaultMessage: "Must not start with any of the excluded values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_END_WITH_ONE_OF]: {
        id: "ecommerce.rules_engine.rule_type.end_with_one_of",
        defaultMessage: "Must end with at least one of the accepted values",
    },
    [ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_END_WITH_ALL]: {
        id: "ecommerce.rules_engine.rule_type.not_end_with_all",
        defaultMessage: "Must not end with any of the excluded values",
    },
})

export const RULE_VALUES_MESSAGES = defineMessages({
    "placeholder": {
        id: "ecommerce.rules_engine.rule_values.placeholder",
        defaultMessage: "Add one or more values to be validated by the rule",
    },
    "boolean_true": {
        id: "ecommerce.rules_engine.rule_values.boolean_true",
        defaultMessage: "True",
    },
    "boolean_false": {
        id: "ecommerce.rules_engine.rule_values.boolean_false",
        defaultMessage: "False",
    },
})

export const FEATURE_TITLE_MESSAGES = defineMessages({
    [ECOMMERCE_RULE_FEATURE.SHOW_ADD_TO_QUOTE]: {
        id: "ecommerce.rules_engine.feature.show_add_to_quote_rules",
        defaultMessage: "Show add to quote rules",
    },
    [ECOMMERCE_RULE_FEATURE.HIDE_ADD_TO_CART_BUTTON_RULES]: {
        id: "ecommerce.rules_engine.feature.hide_add_to_cart_button_rules",
        defaultMessage: "Hide add to cart rules",
    },
    [ECOMMERCE_RULE_FEATURE.HIDE_PRICES_RULES]: {
        id: "ecommerce.rules_engine.feature.hide_prices_rules",
        defaultMessage: "Hide prices rules",
    },
})

export const FEATURE_DESCRIPTION_MESSAGES = defineMessages({
    [ECOMMERCE_RULE_FEATURE.SHOW_ADD_TO_QUOTE]: {
        id: "ecommerce.rules_engine.feature.show_add_to_quote_rules.description",
        defaultMessage: "If enabled without any active rules, the button will show up on all products.",
    },
    [ECOMMERCE_RULE_FEATURE.HIDE_ADD_TO_CART_BUTTON_RULES]: {
        id: "ecommerce.rules_engine.feature.hide_add_to_cart_button_rules.description",
        defaultMessage: "If enabled without any active rules, the button will be hidden for all products. ",
    },
    [ECOMMERCE_RULE_FEATURE.HIDE_PRICES_RULES]: {
        id: "ecommerce.rules_engine.feature.hide_prices_rules.description",
        defaultMessage: "If enabled without any active rules, the prices will be hidden for all products. " +
            "Prices are always hidden for collection pages when this feature is enabled.",
    },
})


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/messages/EcommerceRuleMessages.ts